import api from './api';

const reportService = {
  // Get dashboard statistics
  getDashboardStats: () => {
    return api.get('/api/reports/dashboard-stats');
  },

  // Get income report
  getIncomeReport: (params = {}) => {
    return api.get('/api/reports/income', { params });
  },

  // Get unpaid bills report
  getUnpaidReport: () => {
    return api.get('/api/reports/unpaid');
  },

  // Get occupancy report
  getOccupancyReport: () => {
    return api.get('/api/reports/occupancy');
  },

  // Get partial payments report
  getPartialPaymentsReport: () => {
    return api.get('/api/reports/partial-paid');
  },

  // Get vacant rooms report
  getVacantRoomsReport: () => {
    return api.get('/api/reports/vacant');
  },

  // Get expenses report
  getExpensesReport: (params = {}) => {
    return api.get('/api/reports/expenses', { params });
  },

  // Get tenant payment report
  getTenantPaymentReport: (tenantId, params = {}) => {
    return api.get(`/api/reports/tenant-payments/${tenantId}`, { params });
  },
};

export default reportService;
